import { Middleware } from '@nuxt/types';

const middleware: Middleware = ({ route, app, error }) => {
	if (!app.$vsf.$magento.config.state.getIsMember() && route.path.includes('marketing-materials')) {
		error({ statusCode: 404 });
	}
}

export default middleware;